import { useMemo } from 'react'
import { Badge, CardDownloadFile, SelectOption } from '@iveco-ti/iveco-ds'
import { useFormContext } from '@iveco-ti/iveco-ds/hook-form'
import { ExternalLink } from 'lucide-react'

import DefaultIMG from '@/assets/images/post-default.svg'
import { useEditNewsStore } from '../stores/useEditNewsStore'

export function NewsPreview() {
  const hookForm = useFormContext()
  const { news } = useEditNewsStore()

  const TAGS = hookForm.getValues('tag') as SelectOption[] | null

  const EXTERNAL_URL = hookForm.getValues('postExternalUrl') as string | null

  const TITLE = hookForm.getValues('title') as string | null

  const SUBTITLE = hookForm.getValues('subtitle') as string | null

  const SELECTED_IMAGE = hookForm.getValues('image')

  const IMAGE = useMemo(() => {
    if (SELECTED_IMAGE instanceof File) {
      return URL.createObjectURL(SELECTED_IMAGE)
    }

    if (SELECTED_IMAGE !== null && news?.postImage) {
      return news.postImage
    }

    return DefaultIMG
  }, [SELECTED_IMAGE, news?.postImage])

  const CONTENT = hookForm.getValues('content') as string | null

  const SELECTED_FILE = hookForm.getValues('postFile') as File | null

  const FILE = useMemo(() => {
    if (SELECTED_FILE instanceof File) {
      return SELECTED_FILE
    }

    if (SELECTED_FILE !== null && news?.postFile) {
      return { name: news.postFile.content, size: news.postFile.fileSize }
    }

    return null
  }, [SELECTED_FILE, news?.postFile])

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-2">
          {TAGS?.map((tag: SelectOption) => (
            <Badge.Root key={tag.value} shape="square" size="sm">
              {tag.label}
            </Badge.Root>
          ))}
        </div>

        {EXTERNAL_URL && (
          <a
            href={`https://${EXTERNAL_URL}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink className="text-brand-600 size-5 hover:text-brand-700" />
          </a>
        )}
      </div>

      {TITLE && (
        <h1 className="font-semibold text-2xl text-base-900">
          {hookForm.getValues('title')}
        </h1>
      )}

      {SUBTITLE && (
        <h2 className="text-base-800 text-base font-semibold">
          {hookForm.getValues('subtitle')}
        </h2>
      )}

      <img
        src={IMAGE}
        alt=""
        className="rounded mt-4 max-h-52 w-full object-cover object-center"
      />

      {CONTENT && (
        <div
          dangerouslySetInnerHTML={{ __html: CONTENT }}
          className="no-reset mt-4 flex-1"
        />
      )}

      {FILE && (
        <div className="pb-4">
          <CardDownloadFile.Card
            fileName={FILE.name}
            fileSize={FILE.size}
            onDownload={() => {}}
          />
        </div>
      )}
    </div>
  )
}
